import { SvgIcon } from '@mui/material';
import React from 'react'
export const StatisticsIcon = (props) => {
    return <SvgIcon {...props} enableBackground="new 0 0 48 48" height="24px" version="1.1" viewBox="0 0 48 48" width="24px">
            <g id="Expanded">
                <g>
                    <g>
    <path d="M10,1H2C0.896,1,0,1.896,0,3v40c0,1.104,0.896,2,2,2h8c1.104,0,2-0.896,2-2V3C12,1.896,11.104,1,10,1z" fill={props.style?.color} stroke={props.style?.color} strokeWidth="1" />
                    </g>
                    <g>
<path d="M27.833,15h-8C18.729,15,17,15.11,17,15.864v27.273C17,43.89,18.729,45,19.833,45h8   C28.938,45,29,43.89,29,43.137V15.864C29,15.11,28.938,15,27.833,15z" fill={props.style?.color} stroke={props.style?.color} strokeWidth="1" />
                    </g>
                    <g>
 <path d="M44.5,4h-8C35.396,4,34,4.334,34,5.364v37.273C34,43.666,35.396,45,36.5,45h8c1.104,0,1.5-1.334,1.5-2.363   V5.364C46,4.334,45.604,4,44.5,4z" fill={props.style?.color} stroke={props.style?.color} strokeWidth="1" />
                    </g>
                    <g>
  <path d="M61.5,29h-8c-1.104,0-2.5-0.175-2.5,0.228v14.545C51,44.175,52.396,45,53.5,45h8   c1.104,0,1.5-0.825,1.5-1.228V29.228C63,28.825,62.604,29,61.5,29z" fill={props.style?.color} stroke={props.style?.color} strokeWidth="1" />                    </g>
                </g>
            </g>
    </SvgIcon>
}